<template>

<div>

    <div class="category" :data-id="getId" @drop.stop.prevent="categoryOnDrop($event)" @dragover.stop.prevent="categoryOnDragOver($event)">

        <template v-if="element.category && element.category.id">

            <div class="categoryHeader is-clearfix">

                <!-- IMAGES -->
                <div v-if="element.showCategoryImages === true" :class="['equipmentImagesWrapper', { 'is-large': element.imageSize == 'L' }, { 'is-filled': element.displayedEquipment.length > 0 }]">

                    <div class="equipmentImagesAddButton" @click="equipmentImagesModal=true" title="neues Produktbild hinzufügen">
                        <span class="icon is-small">
                            <i class="fa fa-plus"></i>
                        </span>
                    </div>

                        <draggable
                            v-model="element.displayedEquipment"
                            :options="{
                                handle: '.dragHandle',
                                draggable: '.equipmentImageWrapper',
                            }"
                            @sort="equipmentImageOnDragComplete($event)">

                            <transition-group tag="div" class="equipmentImages">

                                <!--
                                <div class="equipmentImageWrapper" v-for="(el, index) in element.displayedEquipment" v-if="el.equipment != null" :key="el">

                                    <span class="equipmentImageRemove" @click="equipmentImageRemove(index)" title="Bild entfernen">
                                        <span class="icon is-small"><i class="fa fa-minus-square"></i></span>
                                    </span>

                                    <img class="equipmentImage lazy-img-fadein dragHandle" v-lazy="equipmentImageGet(el.equipment)" />

                                    <span class="pzn">{{ el.equipment.extRef }}</span>
                                </div>
                                -->

                                <div class="equipmentImageWrapper" v-for="(el, index) in element.displayedEquipment" v-if="el.equipment != null" :key="el">

                                    <div class="equipmentImage lazy-img-fadein dragHandle" v-lazy:background-image="equipmentImageGet(el.equipment)"></div>

                                    <span class="equipmentImageRemove" @click="equipmentImageRemove(index)" title="Bild entfernen">
                                        <span class="icon is-small"><i class="fa fa-minus-square"></i></span>
                                    </span>
                                    <span class="pzn">{{ el.equipment.extRef }}</span>
                                </div>

                            </transition-group>

                        </draggable>



                </div>

                <!-- TITLE -->
                <div class="categoryTitle">
                    <div class="title" v-html="element.category.name.trim()" @click="goToCategory(element.category.id)"></div>
                    <div class="madeIn" v-if="element.madeIn != null">Hergestellt in {{ element.madeIn}} <img :src="madeInIcon" /></div>
                </div>

                <!-- <div class="categoryTitle" v-html="(element.category.name).trim()" @click="goToCategory(element.category.id)"></div> -->

            </div>


            <!-- TBL HEADLINE -->
            <div class="columns headline">
                <!--
                <div v-for="col in columns" :class="['column', col]">
                  <lang :labelKey="'ECP-TBL_HEADER-'+col.toUpperCase()"></lang>
                </div>
                -->
                <div v-for="header in element.category.headers" :class="['column', header.column]">
                  <div class="label">{{ header.label }}</div><div class="unit">{{ header.unit ? header.unit : '' }}</div>
                </div>

                <div class="border"></div>
            </div>

            <!-- PRODUCTS -->
            <draggable
                v-model="element.category.products"
                :options="{
                    handle: '.dragHandle',
                    draggable: '.columns',
                }"
                @sort="onDragComplete($event)">

                    <transition-group name="test">

                        <div v-for="(product, index) in element.category.products" :key="product.id" class="columns products" v-if="product.equipment != null">

                            <!--
                            <div v-for="col in columns" :class="['column', col]">
                                <template v-if="col=='extRef'">{{ formatExtRef(product.equipment[col]) }}</template>
                                <template v-else-if="col=='priceAEP'">{{ formatPoint2Comma( product.equipment[col], 2) }}</template>
                                <template v-else-if="col=='piecesPerPackage'">{{ addThousandSeparator(product.equipment[col]) }}</template>
                                <span v-else v-html="product.equipment[col] || nl2br((product.equipment.data || {})[col])"></span>
                            </div>
                          -->

                            <div v-for="header in element.category.headers" :class="['column', header.column]">
                                <template v-if="header.column=='extRef'">{{ formatExtRef(product.equipment[header.column]) }}</template>
                                <template v-else-if="header.column=='priceAEP'">{{ formatPoint2Comma( product.equipment[header.column], 2) }}</template>
                                <template v-else-if="header.column=='piecesPerPackage'">{{ addThousandSeparator(product.equipment[header.column]) }}</template>
                                <span v-else v-html="product.equipment[header.column] || nl2br((product.equipment.data || {})[header.column])"></span>
                            </div>

                            <div class="colToolbarContainer">

                                <div class="colToolbar">

                                    <span class="icon is-small dragHandle" title="verschieben">
                                        <i class="icon-ak-move"></i>
                                    </span>

                                    <span class="icon is-small" @click="equipmentDelete(index)" title="löschen">
                                        <i class="icon-ak-entfernen"></i>
                                    </span>

                                    <span class="icon is-small" @click="equipmentGoTo(product.equipment.id)" title="bearbeiten">
                                        <i class="icon-ak-bearbeiten"></i>
                                    </span>

                                </div>

                            </div>


                        </div>

                    </transition-group>

                </draggable>

        </template>


        <template v-else>

            <div class="has-text-centered">
                lade ...
            </div>

        </template>


    </div>

    <!-- MODAL for CATEGORY -->
    <modal title="Auswahl der Kategorie"
        :width="640"
        :is-show="showModal==true"
        :on-ok="categoryModalOnOk"
        :on-cancel="categoryModalOnCancel"
        cancel-text="Abbrechen"
        transition="fadeDown"
        @close="showModal=false"
        v-if="!isLoading"
        class="equipmentModal vcenter">

        <div class="inputContainer">

            <multiselect
                v-model="element.category"
                :options="categories"
                :custom-label="customLabel"
                :allow-empty="false"
                selected-label="aktiv"
                select-label="Klick für Auswahl"
                deselectLabel=""
                placeholder="Suche nach Kategorie"
                label="name"
                track-by="id"
                optionsLimit="10"
                @select="onSelectCategory">

                    <span slot="noResult">Für diesen Suchbegriff konnte keine Kategorie gefunden werden.</span>

            </multiselect>

            <span>-- oder --</span>
            <form-input inputType="text" inputSize="is-medium" v-model="newCategory" placeholder="neuen Kategorienamen eingeben" :isReadOnly="false" :hasLabel="false" :isHorizontal="false"></form-input>

        </div>

    </modal>


    <!-- MODAL for EQUIPMENT IMAGES -->
    <modal title="Produktbilder"
        :width="640"
        :is-show="equipmentImagesModal"
        :on-ok="equipmentImagesModalOnOK"
        :on-cancel="equipmentImagesModalOnCancel"
        cancel-text="Abbrechen"
        transition="fadeDown"
        @close="equipmentImagesModal=false"
        v-if="!isLoading"
        class="vcenter equipmentImagesModal">

        <div class="imgContainer">
            <div :class="[{'is-selected': isEquipmentImageSelected(el) }, 'equipmentImageWrapper']" v-for="(el, index) in equipmentImages" v-if="el.equipment != null" :key="index" @click="equipmentImageAddRemove(el)">
                <img class="equipmentImage lazy-img-fadein" v-lazy="equipmentImageGet(el.equipment)" />
            </div>
        </div>

    </modal>


    <!-- MODAL for NEW EQUIPMENT -->
    <modal title="Neues Produkt"
        :width="640"
        :is-show="equipmentModal"
        transition="fadeDown"
        cancel-text="Abbrechen"
        @close="equipmentModal=false"
        class="vcenter equipmentModal">

        <div class="inputContainer">

            <template v-if="!equipmentModalShowInputFields">

                <multiselect
                    v-model="newEquipment"
                    :options="equipments"
                    :allow-empty="false"
                    selected-label="aktiv"
                    select-label="Klick für Auswahl"
                    deselectLabel=""
                    placeholder="Suche nach Produkt"
                    :custom-label="nameWithExtRef"
                    @select="onSelectNewEquipment"
                    track-by="id"
                    optionsLimit="10">

                        <span slot="noResult">Das Produkt konnte nicht gefunden werden.<br />Möchten Sie ein <strong @click="onActivateShowNewEquipmentInputFields">neues Produkt hinzufügen?</strong></span>

                </multiselect>

            </template>

            <!-- <template v-if="newEquipment!=null && newEquipment.id == null"> -->

            <template v-else>
                <form-input inputType="text" label="EQUIPMENT-EXTREF" inputSize="is-medium" v-model="newEquipment.extRef" :isReadOnly="false" :isHorizontal="false"></form-input>
                <form-input inputType="text" label="EQUIPMENT-NAME" inputSize="is-medium" v-model="newEquipment.name" :isHorizontal="false"></form-input>
            </template>

        </div>


        <div slot="footer" style="width: 100%">
            <button :class="[{ 'is-loading': modalIsSaving }, 'button is-primary is-pulled-right']" @click="modalNewEquipmentOnOk">hinzufügen</button>
            <button class="button is-pulled-right" style="margin-right: 5px;" @click="modalNewEquipmentOnCancel">abbrechen</button>
        </div>

    </modal>



</div>


</template>


<script>
import Multiselect from 'vue-multiselect';
import draggable from 'vuedraggable';

export default {

    name: 'catalogPageElementCategory',

    components: {
        Multiselect,
        draggable
    },

    props: {

        elements: {
            type: Array,
            required: false,
            default: function() { return [] }
        },

        elementIndex: {
            type: Number,
            required: false,
        },

        element: {
            type: Object,
            required: false,
            default: function() { return {} }
        },

    },

    data() {

		return {
            categories: [],
            showModal: false,

            equipments: [],
            equipmentModal: false,
            equipmentModalIsSaving: false,
            equipmentModalShowInputFields: false,
            newEquipment: null,

            equipmentImages: [],
            equipmentImagesModal: false,
            isLoaded: false,
            newCategory: null
        }

    },

    computed: {

        madeInIcon() {

            let img = "";

            switch(this.element.madeIn) {
                case 'AT': img = "at"; break;
                case 'DE': img = "de"; break;
                case 'EU': img = "eu"; break;
                default: img = "nowhere";
            }

            return require(`@/assets/img/madeInIcons/${img}.svg`);

        },

        // get the table columns by splitting the columns string and turn it to an array
        /*
        columns() {
            return this.element.category.columns.split(',');
        },
        */
        columns() {
          return this.element.category.headers;
        },

        getId() {

            if(this.element.category && this.element.category.id) {
                return this.element.category.id;
            }

            return null;

        },

    },

    created() {

        // if a "plain" category was passed, we've to deal with a new field ...
        // if(typeof this.element.category == 'undefined') {
        if(this.element.category == null) {

            this.element.category = {
                name: '',
                content: null,
                products: [],
                equipmentImages: []
            }

            this.fetchCategories();

        }

        if(!this.element.showCategoryImages || this.element.showCategoryImages == null) {
            this.$set(this.element, 'showCategoryImages', false);
        }

        this.$set(this.element, 'categoryHasImages', false);

    },

    mounted() {

        this.initImagePool();

    },

    updated() {

    },

    methods: {

        addThousandSeparator(nStr) {

            nStr += '';
            var x = nStr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;

            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + '.' + '$2');
            }

            return x1 + x2;

        },

        nameWithExtRef ({ name, extRef }) {

			return (name == "" && extRef == "") ? "" : extRef + ' — ' + name;

		},

        categoryOnDrop(ev) {

            let type = JSON.parse(ev.dataTransfer.getData('text/plain')).type.toUpperCase();

            // if dropped element is not of type "EQUIPMENT", we're finished here
            if(type != 'EQUIPMENT') {
                return false;
            }

			this.fetchEquipments();

        },

        categoryOnDragOver(ev) {

        },

        onActivateShowNewEquipmentInputFields() {

            this.newEquipment = {
                extRef: '',
                name: ''
            }

			this.equipmentModalShowInputFields = true;

		},

		modalNewEquipmentOnOk() {

			var self = this;
			this.equipmentModalIsSaving = true;

			if((this.newEquipment.name).trim()== "") {

				this.$notify.warning({content: this.$t('ECP-MSG-NAME_IS_REQUIRED') });
				this.modalIsSaving = false;
				return;

			}

      // add existing product
      if(typeof this.newEquipment.id != 'undefined') {

        var equipmentCategory = {
				id: null,
				category: this.element.category.id,
				sortorder: this.element.category.products.length,
        equipment:  this.newEquipment
			}

      // add completely new product
      } else {

        var equipmentCategory = {
      		id: null,
      		category: this.element.category.id,
      		sortorder: this.element.category.products.length,
          equipment:  {
      			name: this.newEquipment.name,
      			extRef: this.newEquipment.extRef,
      			piecesPerPackage: 0,
      			category: this.element.category.id,
      			asset: null
          }
      	}

      }


			this.entityCreateOrUpdate('equipmentCategoryEquipment?include=equipmentCategoryEquipment.equipment,equipment.asset', equipmentCategory, { msg: 'ECP-MSG-EQUIPMENT_SUCCESSFULLY_ADDED' })
				.then(function(response) {

					// push the new object into the corresponding element
					self.element.category.products.push(response);

					// close the modal
					self.equipmentModal = false;

					// reset saving status
					self.equipmentModalIsSaving = false;

					// reset the "newEquipment" obj
					self.newEquipment = null;
					self.equipmentModalShowInputFields = false;


          // add the product image to the equipmentImages Array
          if(response.equipment.asset != null) {

              let el = {
                  id: null,
                  element: self.element.id,
                  // id: response.id,
                  sortorder: response.sortorder,
                  equipment: response.equipment
              }

              self.initImagePool();

              self.element.hasCategoryImages = true;
          }

			});

		},

		modalNewEquipmentOnCancel() {

			// close the modal
			this.equipmentModal = false;

			// reset the "newEquipment" obj
			this.newEquipment = null;
			this.equipmentModalShowInputFields = false;

		},

    initImagePool() {

        if(this.element.category.products.length > 0) {

            this.equipmentImages = [];      // clear global array first
            var equipmentImagesIds = [];    // helper Array
            var self = this;

            // loop through the products ...
            this.element.category.products.forEach(function(product, index) {

                // if the product doesn't have an asset, continue with next iteration
                if(typeof product == 'undefined' || product.equipment == null || product.equipment.asset == null) {
                    return;
                }

                // if the asset of the product is not in the equipmentImagesIds Array ...
                if(equipmentImagesIds.indexOf(product.equipment.asset.id) == - 1) {

                    // add the ID of the asset to our helper (equipmentImagesIds) Array
                    equipmentImagesIds.push(product.equipment.asset.id);

                    // add the whole obj into the equipmentImages Array
                    let obj = {
                        id: null,
                        element: self.element.id,
                        equipment: product.equipment,
                        sortorder: self.element.displayedEquipment.length
                    }

                    self.equipmentImages.push(obj);

                }

            });

            this.$set(this.element, 'categoryHasImages', equipmentImagesIds.length > 0);

            if(this.element.showCategoryImages == null) {
                this.$set(this.element, 'showCategoryImages', equipmentImagesIds.length > 0);
            }

        } else {

            this.$set(this.element, 'categoryHasImages', false);
            if(this.element.showCategoryImages == null) {
                this.$set(this.element, 'showCategoryImages', false);
            }

        }

    },


    isEquipmentImageSelected(el) {

        for(var i=0; i < this.element.displayedEquipment.length; i++) {

            if(this.element.displayedEquipment[i].equipment != null && this.element.displayedEquipment[i].equipment.asset.id == el.equipment.asset.id) {
                return true;
            }

        }

    },

    equipmentImageAddRemove(el) {

        // let currentLength = this.element.displayedEquipment.length;
        let currentLength = this.element.displayedEquipment.filter(_=>_.equipment != null).length;
        let maxLength = this.element.imageSize == 'L' ? 3 : 5;

        var found = false;
        if(el.equipment.asset != null) {

            for(var i=0; i < this.element.displayedEquipment.length; i++) {

                // if the image was found, we've to remove it from this displayedEquipment Array
                if(this.element.displayedEquipment[i].equipment != null && this.element.displayedEquipment[i].equipment.asset.id == el.equipment.asset.id) {
                    this.equipmentImageRemove(i);
                    found = true;
                }

            }

        }


        if(!found) {

            // if the image wasn't found in the displayedEquipment Array, we add it
            if(currentLength < maxLength) {

                this.element.displayedEquipment.push(el);

            } else {

                this.$notify.open({ content: 'Sie können in dieser Ansicht nur '+maxLength+' Bilder hinzufügen!', type: 'warning'});

            }
        }

    },


    equipmentImageGet(equipment) {

        if(equipment.asset != null) {
            return this.$config.assets + equipment.asset.path + '/thumb/' + equipment.asset.filename;
        }

        return "";

    },

    equipmentImageRemove(index) {

        this.element.displayedEquipment.splice(index, 1);

    },

    equipmentImageOnDragComplete(ev) {

        var self = this;

        this.element.displayedEquipment.forEach(function(el, index) {
            el.sortorder = index;
        })

    },

    equipmentGoTo(id) {

        this.$router.push({ name: 'equipment', params: { 'equipmentID': id }  });

    },

    equipmentDelete(index) {

        var self = this;

        this.$modal.confirm({
            title: self.$t('ECP-DELETE_EQUIPMENT-TITLE'),
            content: self.$t('ECP-DELETE_EQUIPMENT-CONFIRMATION_TEXT'),
            onOk: function() {
                self._deleteEquipment(index);
            },
            okText: self.$t('ECP-DELETE_EQUIPMENT-BTN-OK'),
            cancelText: self.$t('ECP-DELETE_EQUIPMENT-BTN-CANCEL')
        });

    },

    _deleteEquipment(index) {


        // look if there is a corresponding image in the displayedEquipment Array
        // and delete it
        if(this.element.category.products[index].equipment.asset != null) {

            var self = this;

            // remove from displayedEquipment
            this.element.displayedEquipment.forEach(function(el, elIndex) {

                if(el.equipment != null && el.equipment.asset && el.equipment.asset.id == self.element.category.products[index].equipment.asset.id) {
                    self.element.displayedEquipment.splice(elIndex, 1);
                }

            })

            // remove from equipmentImages
            this.equipmentImages.forEach(function(el, elIndex) {

                if(el.equipment.asset.id == self.element.category.products[index].equipment.asset.id) {
                    self.equipmentImages.splice(elIndex, 1);
                }

            })

        }

        // finally remove the equipment
        this.element.category.products.splice(index, 1);

    },

    goToCategory(id) {

        this.$router.push({ name: 'equipmentCategory', params: { 'equipmentCategoryID': id }  });

    },

    onSelectCategory() {

        // console.log("element category: ", this.element.category);

    },

    categoryModalOnOk() {

        // no category given (neither selected nor new)
        // -> we remove the created section
        if(this.element.category.name == "" && (this.newCategory == null || this.newCategory.trim() == "")) {

            this._deleteSection();

        }

        // we've to deal with a new section
        else {

            // insert a completely new category
            if(this.newCategory != null) {

                this._createNewCategory();

            // insert an existing category
            } else {

                this._insertEquipmentCatalogPageElement()

            }


        }

    },

    _createNewCategory() {

        var self = this;
        var newCategoryObj = {
            name: this.newCategory,
            sortorder: this.elementIndex,
            columns: 'extRef,name,piecesPerPackage,priceAEP'
        }

        this.entityCreateOrUpdate('equipmentCategory?include=equipmentCategory.products,equipmentCategoryEquipment.equipment,equipment.asset', newCategoryObj, { isSilent: true })
            .then(function(response) {

                self.elements[self.elementIndex].category = response;

                self._insertEquipmentCatalogPageElement();

        });
    },

    _insertEquipmentCatalogPageElement() {

        var self = this;

        // fill existing tags array
        this.elements[this.element.sortorder].category.aliases.forEach(function(elem) {

            elem.alias['$isDisabled'] = true;
            self.$emit('updateTags', elem.alias);

        })

        // insert the new category, get back the new id of the inserted category
        // and assign the categoryId
        this.entityCreateOrUpdate('equipmentCatalogPageElement', this.elements, { getParams: 'refreshThumbnail=0', isSilent: true })
            .then(function(response) {

                self.$set(self.element, 'id', response.equipmentCatalogPageElement[self.element.sortorder].id);

                if(self.element.content == null) {
                    self.$set(self.element, 'showCategoryContent', false);
                } else {
                    self.$set(self.element, 'showCategoryContent', true);
                }

                self.initImagePool();

            });

    },

    categoryModalOnCancel() {

        this._deleteSection();
        this.showModal = false;

    },

    onDragComplete(ev) {

        var self = this;

        this.element.category.products.forEach(function(product, index) {
            product.sortorder = index;
        })

    },


    formatExtRef(extRef) {

        return extRef != null
            ? extRef.substring(0, extRef.length-1) + ' ' + extRef.charAt(extRef.length-1) + extRef.substring(extRef.length-1 + 1)
            : '-';

    },

    _deleteSection() {

        this.elements.splice(this.elementIndex, 1);

    },


    fetchCategories() {

			var self = this;

			// make the request
            this.axios.get(this.$config.api + 'equipmentCategory?include=equipmentCategory.products,equipmentCategory.aliases,equipmentCategoryEquipment.equipment,equipment.asset')
                .then(function(response) {

					self.categories = response.data.equipmentCategory;
                    self.isLoaded = true;
                    self.showModal = true;

                }).catch(function(error) {
					console.log(error);
				});

        },

		fetchEquipments() {

			var self = this;

			// make the request
			this.axios.get(this.$config.api + 'equipment?include=equipment.asset')
                .then(function(response) {

					self.equipments = response.data.equipment;
					self.equipmentModal = true;

                }).catch(function(error) {
					console.log(error);
				});

		},


    }

}
</script>



<style lang="scss" scoped>

    /* equipment images */
    .equipmentImagesWrapper {

        /*margin-bottom: 10px;*/
        display: flex;
        align-items: center;
        justify-content: flex-end;
        overflow: hidden;

        &.is-filled {
            margin-bottom: 10px;
        }

        .equipmentImagesAddButton {
            background-color: #f5f5f5;
            border-radius: 5px;
            color: #bbb;
            padding: 6px;

            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content:center;
            transition: all .3s ease;

            position: absolute;
            right: -35px;
            left: auto;

            i {
                font-size: 12px;
            }

            &:hover {
                background-color: #e9e9e9;
                color: #222;
            }
        }


        .equipmentImages {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            /*justify-content: flex-end;*/
            overflow: hidden;

            .equipmentImageWrapper {
                position: relative;

                height: 120px;
                width: 33.4mm;

                cursor: move;
                margin: 0;
                padding: 0;
                border-bottom: 1px solid #DADADA;
                transition: all .3s ease;

                .equipmentImage {

                    position: absolute;
                    bottom: 14px;
                    top: 0;
                    left: 6px; right: 6px;

                    background-repeat: no-repeat;
                    background-size: contain;
                    background-position: top center;

                }

                .pzn {
                    position: absolute;
                    bottom: 0;
                    left: 0; right: 0;
                    display: block;
                    font-size: 6pt;
                    color: #666;
                    text-align: center;
                    padding: 0;
                    margin: 0 auto 2px auto;
                }


                &:last-child {

                    &:before {
                        content: "";
                        background: #DADADA;
                        position: absolute;
                        bottom: 0;
                        right: 0;
                        height: 60%;
                        width: 1px;
                    }

                }



                &:after {
                    content: "";
                    background: #DADADA;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    height: 60%;
                    width: 1px;
                }


                .equipmentImageRemove {
                    position: absolute;
                    z-index: 2;
                    display: block;
                    right: 0;
                    top: 0;
                    width: 18px;
                    height: 18px;
                    cursor: pointer !important;
                    opacity: 0;
                    transition: opacity .3s ease;
                }

                &:first-child {
                    margin-left: 0;
                }

                &:hover {
                    .equipmentImageRemove {
                        opacity: 1;
                    }
                }

            }

        }

        &.is-large {

            .equipmentImageWrapper {

                height: 205px;
                width: 55.8mm;

            }

        }

    }

    .isLeftPage {
        .equipmentImagesWrapper {
            justify-content: flex-start;
        }
    }


    .modal {

        ::v-deep .modal-card {
            min-height: 120px !important;
        }

        /* equipment images in modal */
        &.equipmentImagesModal {

            ::v-deep .modal-card {

                /*min-height: 100px !important;*/

                .modal-card-body {

                    padding: 10px !important;

                    .imgContainer {
                        display: flex;
                        align-items: center;
                        /*justify-content: space-between;*/
                        flex-wrap: wrap;

                        .equipmentImageWrapper {
                            height: 112px;
                            width: 112px;
                            cursor: pointer;
                            padding: 10px;
                            margin: 4px;
                            border: 2px solid #ddd;
                            border-radius: 6px;
                            box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
                            transition: border .3s ease;

                            &:hover {
                                border: 2px solid #aaa;
                            }
                            &.is-selected {
                                border: 2px solid #000;
                            }

                            .equipmentImage {
                                height: 100%;
                                width: auto;
                            }

                        }
                    }

                }
            }


        }

        &.equipmentModal {

            .inputContainer {

                width: 95%;
                margin: 0 auto;
                text-align: center;

                .multiselect {
                    margin-bottom: 10px;
                    .multiselect__option {
                        display: block;
                        padding: 12px;
                        min-height: 40px;
                        line-height: 16px;
                        text-decoration: none;
                        text-transform: none;
                        vertical-align: middle;
                        position: relative;
                        cursor: pointer;
                        white-space: nowrap;

                        padding: 5px 8px;
                        min-height: 18px;
                        line-height: 18px;

                        &:after {
                            top:0;
                            right:0;
                            bottom: 0;
                            position:absolute;
                            line-height: 18px;
                            padding: 5px 12px 8px 20px;
                        }

                    }
                }

                > span {
                    color: #aaa;
                    font-style: italic;
                }
                > .control > .control {
                    width: 100%;
                    max-width: 640px;
                }

            }


        }

    }



    .category {

        padding: 0 2px;

        .categoryHeader {

            margin-bottom: 4.2mm;

            .categoryTitle {

                min-height: 16px;
                display: flex;
                align-items: flex-start;

                .title {
                    font-size: 13pt;
                    line-height: 15.6pt;
                    cursor: pointer;
                    flex-grow: 1;
                    margin: 0 10px 0 0;
                }

                .madeIn {
                    text-transform: uppercase;
                    font-size: 10px;
                    font-weight: bold;
                    color: #363636;
                    display: flex;
                    align-items: center;
                    letter-spacing: 1px;
                    flex-basis: 185px;
                    justify-content: flex-end;
                    margin-right: 5px;
                    white-space: nowrap;

                    img {
                        width: 18px;
                        height: 18px;
                        margin-left: 5px;
                    }

                }
            }

        }

        .columns {
            position: relative;
            border-bottom: 1px solid #dcdcdc;
            min-height: 5.8mm;
            align-items: center;
            margin: 0;
            padding: 5px 2px;
            transition: all .6s ease;

            &:not(.headline):hover {
                background: #F5F7F9;
            }

            /* headline columns */
            &.headline {
              position: relative;
              text-transform: uppercase;
              font-size: 7pt;
              border: 0 !important;
              /*height: 7mm;
              min-height: 10mm;
              */
              min-height: 8mm;  
              margin: 0;
              line-height: 1;

              .column {

                .label {
                  margin-bottom: 1pt;
                  font-weight: normal;
                }
                .unit {
                  font-size: 6pt;
                  height: 2mm;
                }
              }

              .border {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                height: 5px;
                background: linear-gradient(to right, #cade74 0%,#87cbf0 100%);
              }
            }



            /*
            .category .columns.headline .column {
                display: flex;
                align-items: center;
            }
            */


            /* column */
            .column {
                /*font-size: 8pt;*/
                font-size: 9pt;
                padding: 0;
                margin: 0;
                overflow: hidden;
                /*flex-basis: 20px;*/
                flex-basis: 5%;
                flex-grow: 1;
                flex-shrink: 0;
                text-align: center;

                span {
                    margin: 0 auto;
                }

                &.name,
                &.name span {
                  /*flex-grow: 2;*/
                  flex-grow: 3;
                  text-align: left;
                  margin: 0;
                }

                &.extRef,
                &.extRef span {
                  flex-basis: auto;
                  flex-grow: 0;
                  flex-shrink: 0;
                  width: 65px;
                  text-align: left !important;
                  margin: 0;
                }


                &.priceAEP,
                &.priceAEP span {
                  flex-basis: auto;
                  flex-grow: 0;
                  flex-shrink: 0;
                  width: 55px;
                  text-align: right !important;
                  margin: 0 0 0 auto;
                }

            }




        }




    }






</style>


<style scoped>

    .ql-editor p {
        margin: 0 !important;
        padding: 0 !important;
    }

    .sortable-ghost {
        background: #aaa;
    }









    .colToolbarContainer {
        position: absolute;
        z-index: 1;
        left: 0;
        top:0;
        bottom:0;
        right: 0;
        transition: all .3s ease;
    }
    .colToolbarContainer .colToolbar {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 3px;
        height: 100%;
        border-radius: 4px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        background-color: #F5F7F9;

        position: absolute;
        z-index: 2;
        left: 0;
        top: 0;
        bottom:0;
        margin-left: 100%;
        padding-left: 5px;


        opacity: 0;  /* Opacity for Modern Browsers */
        -webkit-transition: opacity .3s ease;
        -moz-transition: opacity .3s ease;
        -ms-transition: opacity .3s ease;
        -o-transition: opacity .3s ease;
        transition: opacity .3s ease;
    }
    .colToolbarContainer:hover .colToolbar {
        opacity: 1;
    }

    .colToolbarContainer .colToolbar span.icon {
        color: #888;
        cursor: pointer;
        margin: 0 3px;
        font-size: 11px;
        height: 11px;
        line-height: 11px;
        width: 11px;
        transition: color .2s ease;
    }
    .colToolbarContainer .colToolbar span.icon:hover {
        color: #000;
    }

    .colToolbarContainer .colToolbar span.is-disabled {
        color: #7f56564d;
        cursor: not-allowed !important;
    }
    .colToolbarContainer .colToolbar span.dragHandle {
        /*cursor: n-resize;*/
        cursor: move;
    }

</style>
